module.exports = __webpack_public_path__ + "img/floor_image.3a5c047f.svg";